import React from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components'
import { kategorite } from '../data/kategorite';
import {FaArrowAltCircleUp} from 'react-icons/fa'
import {RiArrowGoBackLine} from 'react-icons/ri'
import { useHistory } from 'react-router';

const Container = styled.div`
    width: 100%;
    margin: 50px auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    position: relative;
`;

const CatContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding-top: 10px;
    padding-bottom: 10px;
`

const Box = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #333;
    padding: 10px 30px;
    margin: 5px;
    border-radius: 10px;
    box-shadow: 2px 2px 18px rgba(0,0,0,0.4);
    text-decoration: none;
    transition: all .3s ease;
    height: 150px;

    &:hover {
        transform: scale(1.03);
    } 
`

const Img = styled.img`
    width: 50px;
`

const CatName = styled.h3`
    -webkit-text-stroke: 1px #fff;
    color: transparent;
    text-transform: capitalize;
    letter-spacing: 2px;
    font-size: 16px;
    
`

const Title = styled.h2`
    text-align: center;
    color: #f9f9f9;
    text-transform: uppercase;
    position: relative;
    margin-bottom: 50px;
`

const TitleSpan = styled.span`
    position: relative;
    color: #333;
    z-index: 99;
    padding: 5px;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #f9f9f9;
        color: #333;
        z-index: -1;
        border-radius: 5px;
        box-shadow: 2px 2px 10px rgba(255,255,255,0.15);
    }
    
`

const BtnContainer = styled.div`
    position: absolute;
    bottom: 10px;
    left: 5%;
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const BackBtn = styled.a`
    color: #f9f9f9;
    padding: 10px;
    font-size: 26px;
    cursor: pointer;
`
const TopBtn = styled.a`
    color: #f9f9f9;
    padding: 5px;
    font-size: 26px;
    cursor: pointer;
    transition: all 1s ease;
`

function MenuCatIta() {

    const history = useHistory();

    const handleBack = () => {
        history.push('/');
    }

    return (
        <Container>
            <Title>Le nostre <TitleSpan>Categorie</TitleSpan></Title>
            <CatContainer>
                {kategorite.map(kat => (
                        <Link to={kat.linkIta} style={{ textDecoration:"none", width: "30%" }} key={kat.id}>
                        <Box>
                            <Img src={kat.img} />
                            <CatName>{kat.ita}</CatName>
                        </Box>
                    </Link>
                    ))}
            </CatContainer>
            <BtnContainer>
                <TopBtn href="#top"><FaArrowAltCircleUp /></TopBtn>
                <BackBtn onClick={handleBack}><RiArrowGoBackLine /></BackBtn>
            </BtnContainer>
        </Container>
    )
}

export default MenuCatIta
